import {useEffect, useState} from "react";
import FunctionsData from "../functions/FunctionsData";
import {
	Button,
	Drawer,
	FormControlLabel,
	Radio, RadioGroup,
	Switch,
	TextField
} from "@mui/material";
import LandingAutoComplete from "./LandingAutoComplete";

export default function Step01(props) {
	
	const [valid, setValid] = useState(false);
	const [exists, setExists] = useState(false);
	const [addressOpen, setAddressOpen] = useState(false);
	const [useSameEmail, setUseSameEmail] = useState(false);
	const [nameExists, setNameExists] = useState(false);
	const [emailExists, setEmailExists] = useState(false);
	function isEmail(val) {
		let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!regEmail.test(val)) {
			return false;
		}
		return true;
	}
	
	function isPhone(val) {
		// let rePhone = /^(\(0\d\)\d{7}|\(02\d\)\d{6,8}|0800\s\d{5,8})$/;
		let valNew = String(val).replace(/null/g,'');
		valNew = String(valNew).replace(/\s/g,'');
		valNew = String(valNew).replace(/-/g,'');
		valNew = String(valNew).replace(/\(/g,'');
		valNew = String(valNew).replace(/\)/g,'').trim();
		let rePhone = /^(((\+64\s*[-\.]?[3-9]|\(?0[3-9]\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{4})|((\+?64\s*[-\.\(]?2\d{1}[-\.\)]?|\(?02\d{1}\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{3,5})|((\+?64\s*[-\.]?[-\.\(]?800[-\.\)]?|[-\.\(]?0508[-\.\)]?|[-\.\(]?0800[-\.\)]?)\s*[-\.]?\d{3}\s*[-\.]?(\d{3,4}|\d{6,7})))$/;
		if (!rePhone.test(val) && val !== '') {
			return false;
		}
		return true;
	}
	
	useEffect(() => {
		window.analytics.track("Signup Stage", {
			stage: 1,
			"Stage name": "Set email"
		});
	}, []);
	
	useEffect(() => {
		props.setState({...props.state, frmEmailFinance: props.state.frmEmail})
	}, [useSameEmail])
	
	useEffect(() => {
		setValid(
			isEmail(props.state.frmEmail) &&
			isEmail(props.state.frmEmailFinance) &&
			props.state.frmAddressFormatted !== '' &&
			props.state.frmBusinessName !== '' &&
			(props.state.frmEmail !== '') &&
			(props.state.frmEmailFinance !== '') &&
			props.state.frmInvoiced !== '' &&
			isPhone(props.state.frmPhone)
		);
	}, [props.state]);
	
	return (
		<div>
			<div className={"form-box"}>
				<p>
					To get started, please provide some information about your clinic..
				</p>
				
				<div>
					<p>Clinic name*</p>
			
			<TextField
				value={props.state.frmBusinessName}
				focused
				onChange={(e) =>
					props.setState({ ...props.state, frmBusinessName: e.target.value })
				  }
				error={
					props.state.frmBusinessName === '' || nameExists
				}
				helperText={
					props.state.frmBusinessName === ''
						? 'Clinic name is required'
						: nameExists
						? 'Clinic name already exists'
						: ''
				}
			/>
		</div>
		
				<div>
					<p>Clinic email*</p>
					<TextField value={props.state.frmEmail} focused
					           onChange={(e) => props.setState({...props.state, frmEmail: e.target.value})}
					           error={!isEmail(props.state.frmEmail)||emailExists}
							   helperText={
								!isEmail(props.state.frmEmail)
									? 'Email is required'
									: emailExists
									? 'Email already exists'
									: ''
							}
					/>
				</div>
				
				<div>
					<FormControlLabel control={
						<Switch checked={useSameEmail}
						        onChange={() => setUseSameEmail(!useSameEmail)}
						        disabled={!isEmail(props.state.frmEmail)}
						/>
					} label="Use the same email for invoicing" />
				</div>
				
				<div style={{opacity:(!isEmail(props.state.frmEmail)) ? '0.3' : '1'}}>
					<p>Finance email for invoicing*</p>
					<TextField value={props.state.frmEmailFinance} focused
					           onChange={(e) => props.setState({...props.state, frmEmailFinance: e.target.value})}
					           error={!isEmail(props.state.frmEmailFinance)}
					           disabled={useSameEmail === true || !isEmail(props.state.frmEmail)}
					/>
				</div>
				
				<div style={{width:'100%'}}>
					<div style={{width:'100%'}}>
						<p>
							Clinic address*
						</p>
						{/*<TextField value={props.state.frmAddressFormatted} focused*/}
						{/*           onChange={(e) => props.setState({...props.state, frmAddressFormatted: e.target.value})}*/}
						{/*           error={props.state.frmAddressFormatted === ''}*/}
						{/*           readonly={true}*/}
						{/*/>*/}
						<p>
							{
								(props.state.frmAddressFormatted === '') ?
									"Please provide the address of your clinic."
									: props.state.frmAddressFormatted
							}
						</p>
					</div>
					<div style={{marginTop:5, width:'100%'}}>
						<ShowAddressSearch {...props} key={Date.now()} open={setAddressOpen} setOpen={setAddressOpen} nodrawer  nameExists={nameExists}  
						       
							   
  setNameExists={setNameExists} emailExists={emailExists} setEmailExists={setEmailExists}/>
					</div>
				</div>
				
				<div>
					<p>Clinic phone</p>
					<TextField value={props.state.frmPhone} focused
					           onChange={(e) => props.setState({...props.state, frmPhone: e.target.value})}
					           error={!isPhone(props.state.frmPhone)}
					/>
					{(!isPhone(props.state.frmPhone)) ? <small style={{color:'red'}}>Please provide a valid NZ phone number</small> : undefined}
				</div>
				
				<div>
					<p>Clinic website</p>
					<TextField value={props.state.frmWebsite} focused
					           onChange={(e) => props.setState({...props.state, frmWebsite: e.target.value})}
					/>
				</div>
				
				<div>
					<p>Have you invoiced SPCA in the last 12months?*</p>
					<RadioGroup
						row
						aria-labelledby="demo-row-radio-buttons-group-label"
						name="row-radio-buttons-group"
						value={props.state.frmInvoiced}
						onChange={(e) => props.setState({...props.state, frmInvoiced: e.target.value})}
						
					>
						<FormControlLabel sx={{color:(props.state.frmInvoiced === '') ? 'red' : null}} value="yes" control={<Radio  />} label="Yes" />
						<FormControlLabel sx={{color:(props.state.frmInvoiced === '') ? 'red' : null}} value="no" control={<Radio  />} label="No" />
						<FormControlLabel sx={{color:(props.state.frmInvoiced === '') ? 'red' : null}} value="unknown" control={<Radio />} label="Unknown" />
					</RadioGroup>
					
				</div>
				
				<div>
					<Button color="primary" sx={{p: '15px', marginLeft: 0}} aria-label="directions"
					        variant={"contained"}
					        disabled={!(valid && exists === false)}
					        onClick={() => props.setStep(props.step + 1)}>
						Next
					</Button>
				</div>
			
			</div>
		</div>
	)
}

const ShowAddressSearch = (props) => {
	
	const [loading,setLoading] = useState(false);
	const [row,setRow] = useState(false);
	
	useEffect(() => {
		
		setRow({
			DPID : props.state.frmDpid,
			POSTCODE: props.state.frmAddressPostcode,
			STREET_NAME: props.state.frmAddressStreet,
			STREET_NUMBER: props.state.frmAddressNumber,
			SUBURB_NAME: props.state.frmAddressSuburb,
			TOWN_CITY_MAILTOWN: props.state.frmAddressCity,
			X_COORDINATE: props.state.frmAddressX,
			Y_COORDINATE: props.state.frmAddressY,
			address: props.state.frmAddressFormatted,
			formatted_address:props.state.frmAddressFormatted
		})
		
	}, [props.state])
	
	useEffect(() => {
		if(loading === true) {
			props.setOpen(false);
		}
	}, [loading])
	
	useEffect(() => {
		console.log("Clinic name changed:", props.state.frmBusinessName);
		if (props.state.frmBusinessName.trim() === '') {
		  props.setNameExists(false);
		  return;
		}
	  
		const checkClientName = async () => {
		  try {
			const response = await fetch(
			  FunctionsData.getApiUrl(`/api/register/account/${encodeURIComponent(props.state.frmBusinessName)}`),
			  {
				method: 'GET',
				headers: {
				  'Content-Type': 'application/json',
				  'token': sessionStorage.tkn
				}
			  }
			);
			const result = await response.json();
			console.log("result", result);
			props.setNameExists(result.data.count > 0);
		  } catch (err) {
			console.error("Error checking clinic name", err);
			props.setNameExists(false);
		  }
		};
	  
		checkClientName();
	  }, [props.state.frmBusinessName]);
	  
	  useEffect(() => {
		console.log("Email changed:", props.state.frmEmail);
		if (props.state.frmEmail.trim() === '') {
		  props.setEmailExists(false);
		  return;
		}
	  
		const checkEmail = async () => {
		  try {
			const response = await fetch(
			  FunctionsData.getApiUrl(`/api/register/accountEmail/${encodeURIComponent(props.state.frmEmail)}`),
			  {
				method: 'GET',
				headers: {
				  'Content-Type': 'application/json',
				  'token': sessionStorage.tkn
				}
			  }
			);
			const result = await response.json();
			console.log("result", result.data.count);
			props.setEmailExists(result.data.count > 0);
		  } catch (err) {
			console.error("Error checking clinic email", err);
			props.setEmailExists(false);
		  }
		};
	  
		checkEmail();
	  }, [props.state.frmEmail]);
	
	function setGooglePlace(row) {
		
		props.setState({
			...props.state,
			frmDpid: row.DPID,
			frmAddressPostcode: row.POSTCODE,
			frmAddressStreet: row.STREET_NAME,
			frmAddressNumber: row.STREET_NUMBER,
			frmAddressSuburb: row.SUBURB_NAME,
			frmAddressCity: row.TOWN_CITY_MAILTOWN,
			frmAddressX: row.X_COORDINATE,
			frmAddressY: row.Y_COORDINATE,
			frmAddressFormatted: row.address,
		})
		
		props.setOpen(false);
	
	}
	
	if(props.nodrawer) return (
		<div style={{margin:0, width:'100%'}}>
			<LandingAutoComplete {...props} row={row} showInline val={props.state.frmAddressFormatted} setGooglePlace={setGooglePlace} setIsLoading={setLoading} />
		</div>
	)
	
	return(
		<Drawer open={props.open} anchor={"right"} onClose={() => props.setOpen(false)}>
			<div style={{margin:20}}>
				<LandingAutoComplete {...props} setGooglePlace={setGooglePlace} close={1} setIsLoading={setLoading} />
			</div>
		</Drawer>
	)
	
}